import React, { ReactElement } from 'react';

import {
  ColoredIllustrationSearchEmptyState,
  ColoredIllustrationSuccess,
  ColoredIllustrationErrorSpendingLimit,
} from '@klarna/bubble-ui';
import { ContractOnboardingStatus } from '@mjolnir/mf-fields-ts/src/enm/ContractOnboardingStatus';

interface ColoredIllustrationProps {
  status?: ContractOnboardingStatus;
}

export const ColoredIllustration: React.FC<ColoredIllustrationProps> = ({
  status,
}: ColoredIllustrationProps): ReactElement => {
  const Component =
    {
      [ContractOnboardingStatus.UNDERWRITING_INITIATED]: ColoredIllustrationSearchEmptyState,
      [ContractOnboardingStatus.MANUAL_UNDERWRITING_INITIATED]: ColoredIllustrationSearchEmptyState,
      [ContractOnboardingStatus.CONTRACT_SIGNED]: ColoredIllustrationSearchEmptyState,
      [ContractOnboardingStatus.ONBOARDING_COMPLETED]: ColoredIllustrationSuccess,
      [ContractOnboardingStatus.SUSPENDED]: ColoredIllustrationErrorSpendingLimit,
      [ContractOnboardingStatus.TERMINATED]: ColoredIllustrationErrorSpendingLimit,
    }[status || ''] || ((): ReactElement => <></>);
  return <Component />;
};
